import React from 'react';

const DeleteUserModalContent = () => {
  return (
    <h5 className="mb-4">Are you sure you want to delete this user?</h5>
  )
}

export default DeleteUserModalContent;